import React, { useState, useEffect } from "react";
import ChatBot from "react-simple-chatbot";
import Swal from "sweetalert2";
import "./chatbot.css";
import { firestore } from "../../firebase/firebase";
import firebase from "firebase/compat/app";
const timestamp = firebase.firestore.FieldValue.serverTimestamp();
const type = "chatbotform";
const logo = "/assets/img/icon.png";

export default function ChatbotUI() {
  const [opened, setopened] = useState(false);

  useEffect(() => {
    setTimeout(function() {
      setopened(true);
    }, 45000);
  }, []);

  const steps = [
    {
      id: "1",
      message: "Hi, Whats your good name?",
      trigger: "2",
    },
    {
      id: "2",
      user: true,
      trigger: ({ value, steps }) => {
        return "3";
      },
    },
    {
      id: "3",
      message: "Hi {previousValue}! How can we help you?",
      trigger: "4",
    },
    {
      id: "4",
      user: true,
      trigger: ({ value, steps }) => {
        return "5";
      },
    },
    {
      id: "5",
      message: "Please provide your mail",
      trigger: "6",
    },
    {
      id: "6",
      user: true,
      inputAttributes: {
        type: "email",
      },
      trigger: ({ value, steps }) => {
        firestore
          .collection("EmailQueries")
          .add({
            to: steps[6]["message"],
            // cc: ["contact@scrobits.com", "digvijay.scrobits@gmail.com"],
            message: {
              subject: "Greetings from ScroBits Technologies",
              text: `Hi ${steps[2]["message"]}, Thank you for taking interest in Scrobits Technologies. Someone from our team will contact you as soon as possibleto help you with your query : ${steps[4]["message"]}`,
              html: "",
            },
            user_info: {
              emailId: steps[6]["message"],
              description: steps[4]["message"],
              fullName: steps[2]["message"],
              type: type,
              timestamp: timestamp,
            },
          })
          .then((res) => {
            console.log("submitted succesfully", res);
          })
          .catch((err) => {
            console.log("error found while subkitting form", err);
          });
        return "7";
      },
    },
    {
      id: "7",
      message: "Thank you!! Kindly check the below link",
      trigger: "8",
    },
    {
      id: "8",
      component: (
        <div>
          <button className="chatbot-form-submit-btn">
            <a href="/get-started">Click here</a>
          </button>
        </div>
      ),
    },
  ];
  const handleFloating = ({ opened }) => {
    setopened(opened);
  };
  return (
    <div className="chatbot-outer-div">
      <ChatBot
        steps={steps}
        opened={opened}
        floating={true}
        toggleFloating={handleFloating}
        headerTitle="Welcome to Scrobits Technologies"
        botAvatar={logo}
      />
    </div>
  );
}
